export default __webpack_public_path__ + "static/media/MiamiCoin.6e8a765b.svg";